import React, { createContext, useState, useEffect, useContext } from 'react';
import { getCompanyData, saveCompanyData as serviceSaveCompanyData,updateCompanyData,findCompanySafe} from '../services/companyService';
import { useAuth } from './AuthContext';

const CompanyContext = createContext();

export const CompanyProvider = ({ children }) => {
  const { currentUser, updateUser } = useAuth();
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setCompany(null);
      setLoading(false);
      return;
    }

    const fetchCompany = async () => {
      setLoading(true);
      try {
        const data = await findCompanySafe();
        if (data) {
          setCompany({ ...data, companyId: data.companyId });
        } else {
          setCompany(null);
        }
      } catch (error) {
        console.error('Erro ao carregar dados da empresa:', error);
        setCompany(null);
      }
      setLoading(false);
    };

    fetchCompany();
  }, [currentUser]);

  /**
   * Salva/atualiza dados da empresa.
   * @param {Object} data 
   */
  const updateCompany = async (data) => {
    if (!currentUser) return;
    if (!company) return;
    await updateCompanyData(company.companyId, data)
    setCompany(data);
  };

  const saveCompanyData = async (data) => {
    if (!currentUser) return;
    var companyId = null;

    if (company && company.companyId) {
      companyId = company.companyId;
    } else{
      companyId = currentUser.companyId;
    }

    var saved = await serviceSaveCompanyData(companyId, data,currentUser);
    if (saved) {
      updateUser(saved.user);
    }
    setCompany(saved.company);
  };
  
  return (
    <CompanyContext.Provider value={{ company, loading, updateCompany, saveCompanyData }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => {
  return useContext(CompanyContext);
};
